import { render, staticRenderFns } from "./NoIniciadosNoInvertidos.vue?vue&type=template&id=1df2cd64&scoped=true"
import script from "./NoIniciadosNoInvertidos.vue?vue&type=script&lang=js"
export * from "./NoIniciadosNoInvertidos.vue?vue&type=script&lang=js"
import style0 from "./NoIniciadosNoInvertidos.vue?vue&type=style&index=0&id=1df2cd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2cd64",
  null
  
)

export default component.exports